import { FC } from 'react';

import { useRouter } from 'next/router';

import { useTheme } from 'styled-components';

import { SPACING } from '~/common/layout-propertis/spacing';
import { allowNewSubscriptions } from '~/common/utils/allow-new-subscriptions';
import { Typography } from '~/common/components/Typography';
import { Modal } from '~/common/components/Modal';
import { Icon } from '~/common/components/Icons';
import { Button } from '~/common/components/Button';
import { AlertInfo } from '~/common/components/AlertInfo';

import { usePrivateLayout } from '../../providers/privateLayout';

interface ISubscriptionUpgradeModalProps {
  open: boolean;
  to: 'platinum' | 'standard';
  close: () => void;
}
export const SubscriptionUpgradeModal: FC<ISubscriptionUpgradeModalProps> = ({
  open,
  to,
  close,
}) => {
  const { isMobile } = usePrivateLayout();
  const theme = useTheme();
  const router = useRouter();
  const canShowSubscriptionCTA = allowNewSubscriptions();

  const handleClickButton = (href: string): void => {
    close();
    router.push(href);
  };

  return (
    <Modal
      id="subscription-upgrade-modal"
      isOpen={open}
      onClose={close}
      width="600px"
      height={isMobile ? (canShowSubscriptionCTA ? '342px' : '286px') : 'auto'}
      hasCloseButton={false}
      {...(to === 'platinum'
        ? {
            customHeader: (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  gap: SPACING._8,
                }}
              >
                <Icon type="Crown" />
                <Typography.Label size="medium">
                  Funcionalidade exclusiva do Plano Platinum
                </Typography.Label>
              </div>
            ),
          }
        : {
            title: 'Assinatura standard necessária',
          })}
    >
      <AlertInfo
        color="neutral.700"
        textColor="neutral.0"
        title={
          canShowSubscriptionCTA
            ? to === 'platinum'
              ? 'Este recurso é exclusivo do plano Platinum.'
              : 'Para acessar essa funcionalidade, você precisa realizar o upgrade para a assinatura standard'
            : to === 'platinum'
              ? 'Este recurso está disponível apenas para usuários com plano Platinum ativo.'
              : 'Esta funcionalidade está disponível apenas para usuários com assinatura Standard ativa.'
        }
        {...(to === 'platinum' && {
          info: canShowSubscriptionCTA
            ? 'Com o plano Platinum, você desbloqueia as ferramentas mais avançadas do sistema e entra em um novo nível de experiência no mercado cripto.'
            : 'No momento, novas assinaturas estão indisponíveis. Se o seu plano atual não inclui este recurso, o acesso permanece bloqueado até a reabertura das assinaturas.',
        })}
      />

      {canShowSubscriptionCTA && (
        <Button
          text="Ir para assinaturas"
          width="100%"
          justifyContent="center"
          onClick={() => handleClickButton('/subscription?startAnnual=true')}
        />
      )}
      {router.asPath === '/radar' ? (
        <Button
          text="Retornar para radar"
          width="100%"
          justifyContent="center"
          backgroundColor={theme.transparent}
          borderColor={theme.green[500]}
          textOrIconColor={theme.green[500]}
          onClick={close}
        />
      ) : (
        <Button
          text="Retornar para o portfolio"
          width="100%"
          justifyContent="center"
          backgroundColor={theme.transparent}
          borderColor={theme.green[500]}
          textOrIconColor={theme.green[500]}
          onClick={() => handleClickButton('/portfolio')}
        />
      )}
    </Modal>
  );
};
